import { atom } from "jotai"
import { TStream } from "types/api"

// 削除モーダルAtom
export type modalState = null | { onClick: () => void } & TStream
export const modalAtom = atom<modalState>(null)

// ストリーム情報新規追加のAdd Button Atom 
export const addButtonAtom = atom(false)